<template>
  <div class="jinshatan-scan-page">
    <img class="banner-img" src="/static/images/jst/banner.png" />
    
    <div class="content-area">
      <p class="instruction-text">点击下方按钮扫码查询</p>

      <div class="scan-button-container">
        <button class="scan-btn" @click="handleScan">
          <i class="fa-solid fa-expand"></i>
        </button>
        <div class="hand-icon">
          <i class="fa-regular fa-hand-pointer"></i>
        </div>
      </div>

      <p class="sub-instruction">若二维码破损请输入数码查询</p>

      <div class="input-group">
        <input type="text" v-model="antiCode" placeholder="请输入16位码进行查询" maxlength="16" @input="validateInput">
        <button class="query-btn" @click="handleQuery">查询</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.jinshatan-scan-page {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
}

.banner-img {
  width: 100vw;
  height: auto;
  display: block;
  z-index: 1;
}

.content-area {
  position: relative;
  z-index: 2;
  padding: 2.67vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  margin-top: 3vh;
}

.instruction-text {
  color: #333;
  font-size: 5vw;
  margin-bottom: 3vh;
  text-align: center;
}

.scan-button-container {
  position: relative;
  margin-bottom: 3vh;
}

.scan-btn {
  width: 28vw;
  height: 28vw;
  border-radius: 50%;
  background: linear-gradient(135deg, #C62828 0%, #EF5350 100%);
  border: none;
  color: white;
  font-size: 5.33vw;
  cursor: pointer;
  box-shadow: 0 0.53vw 2vw rgba(198, 40, 40, 0.4);
  transition: transform 0.3s, box-shadow 0.3s;
}

.scan-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 0.8vw 2.67vw rgba(198, 40, 40, 0.5);
}

.scan-btn:active {
  transform: scale(0.95);
}

.hand-icon {
  position: absolute;
  bottom: -2.33vw;
  right: -1.33vw;
  width: 9vw;
  height: 9vw;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.27vw 1.33vw rgba(0, 0, 0, 0.2);
  animation: bounce 2s infinite;
}

.hand-icon i {
  font-size: 3.2vw;
  color: #C62828;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-1.33vw);
  }
}

.sub-instruction {
  color: #666;
  font-size: 3.6vw;
  margin-top: 3vh;
  margin-bottom: 4vw;
  text-align: center;
}

.input-group {
  display: flex;
  width: 100%;
  max-width: 70vw;
  margin-top: 3vh;
  border: 2px solid #D32F2F;
  height: 10vw;
}

.input-group input {
  flex: 1;
  border: none;
  padding: 0 2vw;
  font-size: 3.8vw;
  outline: none;
}

.input-group input::placeholder {
  font-size: 3.8vw;
  color: #999;
}

.input-group button {
  background-color: #D32F2F;
  color: white;
  border: none;
  padding: 0 5vw;
  font-size: 3.5vw;
  font-weight: bold;
  cursor: pointer;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-card {
  background-color: white;
  border-radius: 2vw;
  padding: 5vw;
  width: 80vw;
  height: 32vh;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.2);
}

.modal-top-text {
  font-size: 3.5vw;
  color: #333;
  margin: 4vw 0;
}

.modal-icon-container {
  display: flex;
  justify-content: center;
  margin: 5vw 0;
}

.modal-icon-container i {
  font-size: 16vw;
  color: #C62828;
  margin: 0 1.5vw;
}

.modal-title {
  font-size: 4vw;
  font-weight: bold;
  color: #333;
  margin: 4vw 0;
}

.modal-btn {
  background-color: #C62828;
  color: white;
  border: none;
  border-radius: 1vw;
  padding: 2vw 4vw;
  font-size: 3vw;
  cursor: pointer;
  margin-top: 4vw;
}
</style>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'JinShaTanScan',
  data() {
    return {
      antiCode: '',
      appId: process.env.ENV_NUM === '1' ? 'wxf2f9904101e550eb' : 'wxbc22565b3e7a59fd',
      eno: process.env.ENV_NUM === '1' ? '138791906387' : '138310353396'
    }
  },
  methods: {
    navigateToResult() {
      this.$router.push({
        path: '/jst/result',
        query: {
          c: this.antiCode,
          isJoin:0
        }
      });
    },
    handleScan() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode", "barCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.antiCode = scanQRCode
          this.navigateToResult()
        }
      });
    },
    handleQuery() {
      if (!this.antiCode) {
        alert('请输入16位防伪码或扫码查询')
        return
      }
      if (this.antiCode.length !== 16) {
        alert('请输入16位防伪码或扫码查询')
        return
      }
      if (!/^\d{16}$/.test(this.antiCode)) {
        alert('请输入16位数字防伪码')
        return
      }
      this.navigateToResult()
    },
    validateInput() {
      // 只允许输入数字
      this.antiCode = this.antiCode.replace(/[^0-9]/g, '')
    },
    async getWxJs() {
       const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted() {
    this.getWxJs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JinShaTan/Scan.vue